import { render, staticRenderFns } from "./TooltipDefault.vue?vue&type=template&id=65a1530f&"
import script from "./TooltipDefault.vue?vue&type=script&lang=js&"
export * from "./TooltipDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports